<script>

import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import ImpressionModels from "@/views/Impression/Components/ImpressionModels.vue";
import {ref, watch} from "vue";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";
import WorkerFilter from "@/views/Worker/Components/WorkerFilter.vue";
import {storeToRefs} from "pinia";
import useTools from "@/use/Tools";

export default {
    components: {WorkerFilter, ImpressionModels},
    setup() {
        const securityStore = useSecurityStore();
        const {idControlProgram, idIssue} = storeToRefs(securityStore);
        const {filter} = useSharedData();
        const {$moment} = useTools();
        const {transformFilterValues} = useSharedMethod();
        
        
        filter.value = {
            phase: "ACTIVE",
            closed: securityStore.userContext.paySlipState || null,
            start: $moment().startOf('year').format('YYYY-MM-DD'),
            end: $moment().format('YYYY-MM-DD'),
            imprimerSiNeant: true
        };
        
        
        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
            idControlProgram.value = null;
            idIssue.value = null;
        }
        
        
        const loading = ref(false);
        const documentUrl = ref(null);
        
        function print() {
            loading.value = true;
            documentUrl.value = null;
            axios.get(`/printed/getMouvementPersonnel`, {
                responseType: 'blob',
                params: transformFilterValues(filter.value)
            }).then(response => {
                const blob = response.data;
                documentUrl.value = window.URL.createObjectURL(blob);
            }).finally(() => {
                loading.value = false;
            })
        }
        
        watch(() => filter.value, () => {
            print();
        }, {deep: true});
        
        return {
            filter,
            loading,
            documentUrl,
            clearFilter,
            print
        }
    }
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.mouvement_personnel')"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <worker-filter v-model="filter"/>
            </template>
            
            <template v-slot:leftToolbar></template>
            <template v-slot:rightToolbar>
                <impression-models/>
                 <w-btn
                    icon="mdi-monitor-arrow-down"
                    color="teal"
                    :text="$t('common.download')"
                    :loading="loading"
                    @press="print"
                />
            </template>
            <template v-slot:content>
                <v-card>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12" md="5">
                                <w-fieldset title="Période">
                                    <v-row>
                                        <v-col cols="12">
                                            <str-cnas-agcency-autocomplete
                                                v-model="filter.cnasAgencyId"
                                                :label="$t('module.cnas_agency')"
                                                set-default
                                                not-clearable
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <w-date-picker
                                                v-model="filter.start"
                                                :label="$t('common.from')"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <w-date-picker
                                                v-model="filter.end"
                                                :label="$t('common.to')"
                                            />
                                        </v-col>
                                        
                                        <v-col cols="6">
                                            <v-checkbox
                                                v-model="filter.eclaterParCodeCNAS"
                                                :label="$t('impression.break_down_by_cnas_code')"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <v-checkbox
                                                v-model="filter.imprimerSiNeant"
                                                :label="$t('impression.print_even_if_nothing')"
                                                hide-details
                                            />
                                        </v-col>
                                        
                                        <v-col cols="6">
                                            <w-text-field
                                                v-model="filter.certifieExacteA"
                                                :label="$t('impression.certified_accurate_to')"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <w-date-picker
                                                v-model="filter.certifieExacteLe"
                                                :label="$t('impression.certified_accurate')"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-col>
                            <v-col cols="12" md="7">
                                <v-container fluid>
                                    <iframe
                                        v-if="documentUrl"
                                        :src="documentUrl"
                                        width="100%"
                                        height="1200px"
                                        name="myIframe"
                                    />
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>

<style scoped>

</style>